import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const whatsappNumber = '5544999448428';
  const message = 'Olá! Gostaria de explorar a coleção de relógios de luxo da ART TIME.';
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/7627873/pexels-photo-7627873.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Luxury watch background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-6 md:px-12 max-w-5xl mx-auto text-center">
        <motion.div
          className="uppercase text-[#C9A646] font-sans text-xs md:text-sm tracking-[0.3em] mb-8"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          data-testid="hero-overline"
        >
          Curadoria Exclusiva
        </motion.div>

        <motion.h1
          className="font-serif text-4xl sm:text-5xl lg:text-7xl text-white mb-6 leading-tight tracking-tight"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          data-testid="hero-headline"
        >
          O Tempo é a Sua Maior <br />Obra de Arte.
        </motion.h1>

        <motion.p
          className="font-sans text-base md:text-lg text-[#A3A3A3] max-w-2xl mx-auto mb-12 leading-relaxed"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          data-testid="hero-subheadline"
        >
          Curadoria exclusiva de relógios originais. Elevando o padrão de sofisticação e precisão.
        </motion.p>

        <motion.div
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <button
            onClick={() => scrollToSection('colecao')}
            className="bg-[#C9A646] text-black font-semibold hover:bg-white transition-all duration-300 px-8 py-4 flex items-center gap-2 group"
            data-testid="hero-cta-explore"
          >
            Explorar Coleção
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="border border-[#C9A646] text-[#C9A646] hover:bg-[#C9A646] hover:text-black transition-all duration-300 px-8 py-4"
            data-testid="hero-cta-whatsapp"
          >
            Contato via WhatsApp
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 10, 0] }}
        transition={{ opacity: { delay: 1 }, y: { repeat: Infinity, duration: 1.5 } }}
      >
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-[#C9A646] rounded-full"></div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
